import { getSelectorRoot } from 'utils/selectors';

const getESportData = getSelectorRoot('eSportData');

export const getSport = getESportData('sport');
export const getCachedSport = getESportData('cashedSport');
export const getGames = getESportData('games');
export const getGamesSingleViewData = getESportData('gamesSingleViewData');
export const getAdditionalStatisticsData = getESportData(
  'additionalStatisticsData'
);
